import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styled, { css } from 'styled-components';
import { getBackgroundColor, themeGet } from '@magalu/stereo-ui-styles';
import BaseItem from '../../atoms/Item';
import Collapse from '../../atoms/Collapse';
import { Grid } from '../../atoms';

const buildBorderWidth = ({
  gutters,
  basis = 0,
  inset = 0,
  props
}) => {
  return themeGet(`space.${gutters}`)(props) + parseInt(basis, 10) * Number(inset);
};

const buildHorizontalList = ({
  horizontal
}) => horizontal && css`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(30px, max-content));
    justify-content: space-between;
  `;

const buildBorder = css`
  > *:not(:last-child) {
    border-bottom: ${themeGet('borders.0')};
  }
`;
export const ItemWrapper = styled.li({
  listStyle: 'none',
  position: 'relative'
});
export const Item = styled(BaseItem).attrs(_ref => {
  let {
    inset,
    basis,
    gutters,
    content,
    horizontal
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["inset", "basis", "gutters", "content", "horizontal"]);

  return Object.assign({
    position: 'relative',
    gap: 0,
    rowGap: 2,
    px: 0,
    py: content ? 2 : 0,
    pl: inset ? buildBorderWidth({
      gutters,
      basis,
      inset,
      props
    }) : buildBorderWidth({
      gutters,
      props
    }),
    pr: buildBorderWidth({
      gutters,
      props
    })
  }, horizontal && {
    textAlign: 'center',
    pl: 0,
    pr: 0
  }, props);
})`
  cursor: pointer;
  ${({
  selectable
}) => selectable && css`
      &:hover {
        background: ${getBackgroundColor('darker')};
      }
    `};

  ${({
  horizontal
}) => horizontal && css`
      > span {
        position: unset;
        transform: unset;
        left: 0;
      }
    `}

  ${({
  divided,
  isCollapsed
}) => divided && !isCollapsed && css`
      border-top: ${themeGet('borders.0')};
    `}
`;
export const ListDefault = styled(Grid)`
  ${({
  divided
}) => divided && buildBorder}
  ${buildHorizontalList}
`;
export const ListCollapse = styled(Collapse)`
  ${({
  divided
}) => divided && buildBorder}
  ${buildHorizontalList}
`;